import PropTypes from "prop-types";
import TextInput from "../Inputs/TextInput";

function ValueStep({
  title,
  description,
  statekey,
}: {
  title: string;
  description: string;
  statekey: string;
}) {
  return (
    <div className="Step ValueStep">
      <h2>{title}</h2>
      <p>{description}</p>
      <TextInput
        placeholder="Please enter the approximate value in £££"
        currency={true}
        statekey={statekey}
      />
    </div>
  );
}

export default ValueStep;

ValueStep.propTypes = {
  options: PropTypes.array,
  statekey: PropTypes.string,
  state: PropTypes.object,
  updateState: PropTypes.func,
};
